import { Injectable } from '@angular/core';
import { JwtBearerHelperService } from './jwt-bearer-helper.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ILogin } from '@core/interfaces/authentication/ilogin';
import { IAuthenticatedResponse } from '@core/models/authentication/iauthenticated-response.model';
import { IApiResponse } from '@core/models/iapi-response.model';
import { CiudadanoDatosService } from '../ciudadano/ciudadano-datos.service';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private API_URL = environment.api_url;

  constructor(
    protected $http: HttpClient,
    private _jwtService: JwtBearerHelperService,
    private _ciudadanoDatosService: CiudadanoDatosService,
  ) {}

  get isAuthenticated(): boolean {
    return this._jwtService.hasToken && !this._jwtService.isTokenExpired;
  }

  public login(model: ILogin): Observable<IApiResponse<IAuthenticatedResponse>> {
    const formData = new FormData();
    formData.append('codigo', model.codigo);
    formData.append('clave', model.clave);
    return this.$http.post<IApiResponse<IAuthenticatedResponse>>(
      `${this.API_URL}/auth/iniciar-sesion`,
      formData,
    );
  }

  public refreshToken(token: string) {
    return this.$http.get<IApiResponse<IAuthenticatedResponse>>(
      `${this.API_URL}auth/refresh-token`,
      {
        headers: {
          'refresh-token': token,
        },
      },
    );
  }

  public logout() {
    this._jwtService.clearToken();
    this._ciudadanoDatosService.limpiarDatosGeneralesCiudadano();
  }

  public closeSession() {
    this._jwtService.clearToken();
    this._ciudadanoDatosService.limpiarDatosGeneralesCiudadano();
    window.location.replace('/');
  }

  public iniciarSolicitudRecuperacionClave(email: string) {
    const payload = { correo_electronico_usuario: email };
    return this.$http.post<{ solicitud_gestion_usuario_id: number; token: string }>(
      `${this.API_URL}/auth/solicitud-recuperacion-clave`,
      payload,
    );
  }

  public validarRecuperacionClave(codigo: number) {
    const params = new HttpParams().set('codigo_seguridad', codigo);
    return this.$http.get<{ token: string; status: boolean }>(
      `${this.API_URL}/auth/validar-recuperacion-clave`,
      {
        params: params,
      },
    );
  }

  public completarRecuperacionClave(newPassword: string) {
    const payload = { nueva_clave: newPassword };
    return this.$http.post(`${this.API_URL}/auth/completar-recuperacion-clave`, payload);
  }
}
